import { render, staticRenderFns } from "./urunler.vue?vue&type=template&id=2cfa1e10&scoped=true&"
import script from "./urunler.vue?vue&type=script&lang=js&"
export * from "./urunler.vue?vue&type=script&lang=js&"
import style0 from "./urunler.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./urunler.vue?vue&type=style&index=1&id=2cfa1e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa1e10",
  null
  
)

export default component.exports